import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { toast } from 'sonner';

export default function SuccessPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const sessionId = searchParams.get('session_id');

  useEffect(() => {
    if (sessionId) {
      toast.success('Platba byla úspěšná! Kredity byly přidány na váš účet.');
      // Přesměrování na projekty po 3 sekundách
      const timeout = setTimeout(() => {
        navigate('/projects');
      }, 3000);

      return () => clearTimeout(timeout);
    }
  }, [sessionId, navigate]);

  return (
    <div className="max-w-2xl mx-auto p-6 text-center">
      <h1 className="text-3xl font-bold mb-4">Platba byla úspěšná!</h1>
      <p className="text-gray-600 mb-6">
        Děkujeme za váš nákup. Kredity byly přidány na váš účet.
      </p>
      <p className="text-sm text-gray-500">
        Za chvíli budete přesměrováni na vaše projekty...
      </p>
    </div>
  );
} 